export default "__VITE_ASSET__BnxEdhAf__"